/* eslint-disable import/no-cycle */
import React, { } from 'react';
import { Header } from '../components';

import './Zackat.css';

const NotFound = () => (
  <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
    <Header category="" title="404 - Not Found" />
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <h2>Sorry, the page you are looking for could not be found.</h2>
    </div>
  </div>
);
export default NotFound;
